/* Package JSON Import will be here */
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import * as actions from '../../actions/login.Action';
import * as dateActions from '../../actions/date.Action';
import LoginComponent from './login.Component';
import { MessageBox } from '../sharedComponent/messageBox';
import * as onDefaultGroupByAction from '../../actions/timecardDefaultGroupBy.Action';
import * as utility from '../../services/utility';
/* Package JSON Import will be here */
/* Project Import will be here */


/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employeePin: "",
            isShowLoader: false,
            inputRef: createRef()
        }
    };

    componentDidMount(){
        window.addEventListener('storage', () => {
            let checkReduxState = JSON.parse(localStorage.reduxState);
            if (checkReduxState.loginReducer && checkReduxState.loginReducer.user && checkReduxState.loginReducer.user.loggedIn && window.location.pathname === "/Login") {
                this.props.login(true, checkReduxState.loginReducer.user.employeeNumber, 
                    checkReduxState.loginReducer.user.employeeId, checkReduxState.loginReducer.user.deviceId, 
                    checkReduxState.loginReducer.user.deviceEmpID, checkReduxState.loginReducer.user.empFullName, 
                    checkReduxState.loginReducer.user.accessToken);
                this.props.onSelectDate(new Date());
                this.props.groupByInTimecardPage('');
            }
        });
        this.makeInputFocus();
        window.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillMount() {
        this.checkAndNavigatToAnotherPage();
    }

    componentWillUnmount(){
        window.removeEventListener('keydown', this.handleKeyPress);
    }

    onClickFocusInput(){
        let { employeePin } = this.state;
        let inputRef = this.state.inputRef.current.inputRef;
        inputRef.current.setSelectionRange(employeePin.length, employeePin.length);
        inputRef.current.focus();
    }

    checkAndNavigatToAnotherPage() {
        if (this.props.user.loggedIn) {
            this.props.history.push("/Timecard");
        }
    }


    onClickClear = () => {
        this.setState({
            employeePin: ''
        });
        this.makeInputFocus();
    }

    onClickNumbericInput = (value) => {
        let { employeePin } = this.state;
        employeePin += value;
        this.setState({ employeePin });
    }

    onClickDeviceNameUpdate = () => {
        this.props.history.push("/Register");
    }

    onClickLogin = () => {
        let { employeePin } = this.state;
        let checkReduxState = JSON.parse(localStorage.reduxState);
        if (checkReduxState.loginReducer && checkReduxState.loginReducer.user && checkReduxState.loginReducer.user.roleName !== "" && checkReduxState.loginReducer.user.empFullName !== "" && checkReduxState.loginReducer.user.loggedIn) {
            MessageBox(checkReduxState.loginReducer.user.empFullName + " has logged in another tab, please log out and log in as another user", Constants.ERROR);
        } else {
            if (!employeePin) {
                MessageBox('Please enter the employee pin', Constants.ERROR);
                this.makeInputFocus();
                return;
            }
            let url = ApiUrls.Routes.ACNT_C + ApiUrls.Routes.WNDS_LN_M + `?deviceFingerPrintId=${this.props.device.deviceFingerPrintId}&employeePin=${employeePin}`;
            Api.Get(url, this).then((responseData) => {
                if (responseData.success) {
                    utility.setupActivityListeners();
                    this.props.login(true, responseData.data.employeeNumber, responseData.data.employeeId, responseData.data.deviceId, responseData.data.deviceEmpID, responseData.data.empFullName, responseData.token.result);
                    this.props.onSelectDate(new Date());
                    this.props.groupByInTimecardPage('');
                    this.props.history.push("/TimeCard", { isFromLogin: true });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                    setTimeout(() => {
                        this.makeInputFocus();
                        this.setState({
                            employeePin: ''
                        });
                    }, 1000)
                }
            });
        }
    }

    handleInputChange(e) {
        let { employeePin } = this.state;
        const inputRegex = /^[0-9\b]+$/;
        employeePin = e.target.value;
        if(employeePin === '' || inputRegex.test(employeePin)){
            this.setState({ employeePin });
        }
    }

    makeInputFocus(){
        if(this.state.inputRef.current) this.state.inputRef.current.focus();
    }

    handleKeyPress = (keyEvent) => {
        if(keyEvent.key === 'Enter'){
            keyEvent.preventDefault();
            this.onClickLogin();
        }
    }

    render() {
        const { employeePin, inputRef } = this.state;
        return (
            <LoginComponent
                {...{
                    login: {
                        employeePin,
                        inputRef
                    }
                }}
                onClickClear={this.onClickClear.bind(this)}
                onClickLogin={this.onClickLogin.bind(this)}
                onClickDeviceNameUpdate={this.onClickDeviceNameUpdate.bind(this)}
                onClickNumbericInput={this.onClickNumbericInput.bind(this)}
                handleInputChange={this.handleInputChange.bind(this)}
                onClickFocusInput={this.onClickFocusInput.bind(this)}
            />
        );
    };

}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions, dateActions, onDefaultGroupByAction),
        dispatch);
}

Login.displayName = 'Login';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));